import { TEXT_ALIGNMENT, WIDGET_DEFAULT_FONT } from 'constants/fonts';
import { WidgetType } from 'types/widget.types';

import { DEFAULT_FORM_FIELD_VALUE } from './FormWidget.config';
import {
  FontStyleOption,
  FontWeightOption,
  FormType,
  InputType,
  LabelAlignment,
  LabelPosition,
  TextDecorationOption,
} from './FormWidget.types';
import { VERSION } from './FormWidget.upgrade';

export const generateDefaultData = (type: FormType = FormType.ShortQuestion) => {
  return {
    widgetType: WidgetType.Form,
    widgetData: {
      version: VERSION,
      widthPx: 300,
      heightPx: 76,
      topPx: 0,
      leftPx: 0,
      rotateDeg: 0,
      // Default form widget data
      type,
      style: {
        lineHeight: '1',
        fontWeight: FontWeightOption.Normal,
        fontStyle: FontStyleOption.Normal,
        textDecoration: TextDecorationOption.None,
        fontSize: 16,
        fontFamily: WIDGET_DEFAULT_FONT,
        textAlign: TEXT_ALIGNMENT.left,
        alignSelf: LabelAlignment.center,
        color: '#000',

        backgroundColor: '#fff',
        borderRadius: 6,
        borderColor: '#8c8c8c',
        borderWidth: 1,

        gap: 12,
      },
      altText: FormType.ShortQuestion,
      isDecorative: false,
      submitButtonLabel: 'Submit',
      field: DEFAULT_FORM_FIELD_VALUE[InputType.Text],
      labelPosition: LabelPosition.Top,
    },
  };
};
